import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByKeyPipe',
})
export class groupByKeyPipe implements PipeTransform {
  transform(value, key): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const groupName = o[key];
          const EventDateIso = o.EventDateIso;
          groups[groupName] = groups[groupName] ? groups[groupName] : { EventDateIso: EventDateIso, eEvents: [] };
          groups[groupName].eEvents.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
